import {
  Button,
  ButtonGroup,
  Grid,
  Link,
  SvgIcon,
  TableSortLabel,
  Typography,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import MoreVertRoundedIcon from "@material-ui/icons/MoreVertRounded";
import { IconFlagCA, IconFlagUS } from "material-ui-flags";
import SearchBar from "material-ui-search-bar";
import React, { useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";
import toast from "react-hot-toast";
import { useHistory } from "react-router-dom";
import { ReactComponent as INLogo } from "../images/inflag.svg";
import http from "../services/httpService";
import staticFiles from "../services/staticApi";
import {
  addInvestmentPath,
  concatEfg,
  editInvestmentPath,
  getDate,
  handleSort,
  investmentDetailsPath,
  searchFilter,
} from "../utils/varialbles";

const getFlags = (country) => {
  let CountryMapper = {
    India: (
      <SvgIcon>
        <INLogo />
      </SvgIcon>
    ),
    USA: IconFlagUS,
    Canada: IconFlagCA,
  };
  if (country && CountryMapper[country] && country !== "India") {
    return React.createElement(CountryMapper[country]);
  } else {
    return CountryMapper["India"];
  }
};
const columns = [
  { id: "Investment_Name", label: "Investment Name", minWidth: 170 },
  { id: "Asset_Class", label: "Asset class", minWidth: 150 },
  { id: "Country", label: "Country", minWidth: 150 },
  { id: "Sector", label: "Sector", minWidth: 150 },
  { id: "Industry", label: "Industry", minWidth: 150 },
  { id: "ISINCode", label: "ISIN code", minWidth: 150 },
  {
    id: "Microcap",
    label: "Micro-Cap Investments",
    minWidth: 150,
    format: "boolean",
  },
  { id: "IPO", label: "IPO Investments", minWidth: 150, format: "boolean" },
  { id: "NFO", label: "NFO Investments", minWidth: 150, format: "boolean" },
  { id: "ELSS", label: "ELSS Category", minWidth: 150, format: "boolean" },
  { id: "Status", label: "Recommendations status", minWidth: 150 },
  { id: "Rscore", label: "R Score", minWidth: 150, format: "number" },
  { id: "Iscore", label: "I Score", minWidth: 150, format: "number" },
  {
    id: "Research_Note",
    label: "Research Note",
    minWidth: 150,
    format: "link",
  },
  {
    id: "concatvalue",
    label: "EFG Investment score correspondence range",
    minWidth: 150,
  },
  { id: "options", label: "Options", minWidth: 150 },
];

const Q1Columns = [
  { id: "ISINCode", label: "ISIN code", minWidth: 170 },
  { id: "year", label: "Year", minWidth: 150 },
  { id: "Investment_Name", label: "Company Name", minWidth: 150 },
  { id: "Industry", label: "Industry", minWidth: 150 },
  { id: "Sector", label: "Sector", minWidth: 150 },
  { id: "quartiles", label: "Quartiles", minWidth: 150 },
];

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
function VintageOverView({ tabName }) {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("cust__createddt");
  const [order, setOrder] = React.useState("asc");
  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];

    setPage(0);
    setRows(searchFilter(searchedVal, rowsTemp));
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };
  const history = useHistory();
  const [activeInv, setActiveInv] = useState(true);
  const [watchList, setwatchList] = useState(false);
  const [q1List, setQ1List] = useState(false);
  const [fallBack, setFallBack] = useState(false);
  const [currentType, setCurrentType] = useState(1);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [currentRecord, setCurrentRecord] = useState({});
  const isMenuOpen = Boolean(anchorEl);
  const [proofSrc, setProofSrc] = React.useState({});
  const [researchNoteList, setResearchNoteList] = useState([]);
  const [columnList, setColumnList] = useState(columns);
  const [open, setOpen] = useState(false);
  const [deleteopen, setDeleteopen] = useState(false);
  const [dialogopen, setDialogopen] = useState({
    activeInvestment: false,
    watchList: false,
    FallbackList: false,
  });
  const [otpField, setotpField] = useState("");

  const fileInputRef = useRef(null);
  const deleteResearchNote = (e, object) => {
    e.preventDefault();
    if (object && object.list_id) {
      http
        .delete("deleteresearchnote?list_id=" + object.list_id)
        .then((res) => {
          toast.success(res.data.Data);
          if (proofSrc && proofSrc.id) {
            openResearchNote(proofSrc);
          }
        })
        .catch((err) => {});
    } else if (object && object.id) {
      http
        .delete("deleteresearchnote?id=" + object.id)
        .then((res) => {
          toast.success(res.data.Data);
          if (proofSrc && proofSrc.id) {
            openResearchNote(proofSrc);
          }
        })
        .catch((err) => {});
    } else {
      toast.error("Research note deletion failed..!");
    }
  };
  const handleEditRecord = (e, record) => {
    history.push({
      pathname: editInvestmentPath,
      state: currentRecord,
    });
    setAnchorEl(null);
  };
  const handleFileUpload = (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append(
      "Research_Note",
      event.target.files[0],
      event.target.files[0].name
    );
    formData.append("list", proofSrc.id);
    http
      .post("/uploadresearchnote", formData)
      .then((res) => {
        toast.success(res.data.Data);
        if (proofSrc && proofSrc.id) {
          openResearchNote(proofSrc);
        }
      })
      .catch((err) => {});
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleDeleteClose = () => {
    setDeleteopen(false);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);

    setRows(finalRows);
    setPage(0);
  };

  const handleOTP = (e) => {
    setotpField(e.target.value);
    // console.log(otpField, "OTP");
  };

  const getActiveButton = (name) => {
    setActiveInv(false);
    setwatchList(false);
    setFallBack(false);
    setQ1List(false);
    setOriginalRows([]);
    setRows([]);
    setPage(0);
    if (name === "activeInv") {
      setActiveInv(true);
      setColumnList(columns);
      getVantageList(1);
      setCurrentType(1);
    } else if (name === "watchList") {
      setwatchList(true);
      setColumnList(columns);
      getVantageList(2);
      setCurrentType(2);
    } else if (name === "fallBack") {
      setFallBack(true);
      getVantageList(3);
      setColumnList(columns);
      setCurrentType(3);
    } else if (name === "q1List") {
      setQ1List(true);
      setColumnList(Q1Columns);
      getQ1List();
    }
  };
  const handleMenuOpen = (event, record) => {
    let currentTarget = event.currentTarget;
    setCurrentRecord(record);
    setAnchorEl(currentTarget);
  };

  //Edit here

  const ToggleDialog = (e, type) => {
    const actionobj = {
      Action: "",
      Stock: currentRecord.Investment_Name,
      Section: "",
    };

    switch (currentType) {
      case 1:
        actionobj.Section = "Active Investments";
        break;
      case 2:
        actionobj.Section = "Watch List";
        break;
      case 3:
        actionobj.Section = "Fallback List";
        break;
    }

    if (type === 2) {
      setDialogopen({ ...dialogopen, watchList: true });

      actionobj.Action = "Move to WatchList";
      requestOTP(actionobj);
    }
    if (type === 3) {
      setDialogopen({ ...dialogopen, FallbackList: true });
      actionobj.Action = "Move to FallbackList";
      requestOTP(actionobj);
    }
    if (type === 1) {
      setDialogopen({ ...dialogopen, activeInvestment: true });
      actionobj.Action = "Move to Active Investment";
      requestOTP(actionobj);
    }
  };

  function requestOTP(actionobj) {
    switch (currentType) {
      case 1:
        actionobj.Section = "Active Investments";
        break;
      case 2:
        actionobj.Section = "Watch List";
        break;
      case 3:
        actionobj.Section = "Fallback List";
        break;
    }

    http
      .post("/verification_view", actionobj)
      .then((res) => {
        toast.success("OTP Sent Successfully!");
      })
      .catch((err) => {
        toast.error("OTP Request Failed!");
      });
  }

  //deleted function argument row

  /**
   * The function `handlePatchRecord` sends a PATCH request to update a record in the company list with
   * a specified type and OTP, and then retrieves the updated list.
   * param type - The `type` parameter is a variable that represents the Menu Items Active Investment(1), WatchList(2), FallBackList(3) being patched.
   */
  const handlePatchRecord = (e, type) => {
    http
      .patch(
        "/companylistedit/" + currentRecord.id + "/" + "?otp=" + otpField,
        { type: type }
      )
      .then((res) => {
        getVantageList(currentType);
        setAnchorEl(null);
        setCurrentRecord({});
        setotpField("");
        setDialogopen({
          activeInvestment: false,
          watchList: false,
          FallbackList: false,
        });
      })
      .catch((err) => {
        toast.error("Move Action Failed!");
      });
  };

  const handleDeleteRecord = (e, record) => {
    setDeleteopen(true);
    const actionobj = {
      Action: "Delete",
      Stock: currentRecord.Investment_Name,
      Section: "",
    };

    switch (currentType) {
      case 1:
        actionobj.Section = "Active Investments";
        break;
      case 2:
        actionobj.Section = "Watch List";
        break;
      case 3:
        actionobj.Section = "Fallback List";
        break;
    }

    http
      .post("/verification_view", actionobj)
      .then((res) => {
        toast.success("OTP Sent Successfully!");
      })
      .catch((err) => {
        toast.error("OTP Request Failed!");
      });
  };

  const submitDelete = (e) => {
    http
      .delete("/companylistedit/" + currentRecord.id + "/" + "?otp=" + otpField)
      .then((res) => {
        toast.success("Record Deleted Successfully!");
        setDeleteopen(false);
        getVantageList(currentType);
        setAnchorEl(null);
        setCurrentRecord({});
        setotpField("");
      })
      .catch((err) => {
        toast.error("Record Delete Failed!");
      });
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const viewInvestmentDetails = (object) => {
    history.push({
      pathname: investmentDetailsPath,
      state: object,
    });
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const openResearchNote = (proof) => {
    if (proof && proof.id) {
      http
        .get("/researchnotelist/" + proof.id)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.Data &&
            Array.isArray(response.data.Data) &&
            response.data.Data.length > 0
          ) {
            setResearchNoteList(response.data.Data);
          } else {
            setResearchNoteList([]);
          }
          setOpen(true);
          setProofSrc(proof);
        })
        .catch((error) => {});
    } else {
      setResearchNoteList([]);
    }
  };

  const addInvestmentButton = (e) => {
    history.push({
      pathname: addInvestmentPath,
      state: e,
    });
  };
  const getVantageList = (type) => {
    toast.loading("Please wait...");

    http
      .get("/vantagelists?type=" + type)
      .then((response) => {
        toast.dismiss();
        if (response && response.data && response.data.Data) {
          setOriginalRows(response.data.Data);
          setRows(response.data.Data);

          setPage(0);
        }
      })
      .catch((error) => {});
  };
  const getQ1List = () => {
    toast.loading("Please wait...");

    http
      .get("/q1list")
      .then((response) => {
        if (response && response.data && response.data.Data) {
          setOriginalRows(response.data.Data);
          setRows(response.data.Data);
          setPage(0);
          toast.dismiss();
        }
      })
      .catch((error) => {});
  };
  useEffect(() => {
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter");
    localStorage.removeItem("selectedfiltersdata");
    localStorage.removeItem("selectedinvestorfiltersdata");

    if (tabName && tabName == "Watch List") {
      getActiveButton("watchList");
    } else {
      getVantageList(1);
    }
  }, []);

  return (
    <>
      <Grid item xs={12} className={"efgBtn"} align="right">
        <Button
          color="primary"
          style={
            watchList
              ? { display: "block", lineHeight: "unset", marginTop: "10px" }
              : { display: "none" }
          }
          variant="contained"
          onClick={(e) => addInvestmentButton(e)}
        >
          Add Recommendation
        </Button>
      </Grid>

      <Grid container style={{ padding: "10px 0" }}>
        <Grid item xs={12} align="center">
          <ButtonGroup
            aria-label="outlined primary button group"
            classes={"buttongroup"}
            style={{ marginBottom: "10px" }}
          >
            <Button
              variant="contained"
              color={activeInv ? "primary" : "default"}
              onClick={(e) => getActiveButton("activeInv")}
            >
              Active Investments
            </Button>
            <Button
              variant="contained"
              color={watchList ? "primary" : "default"}
              onClick={(e) => getActiveButton("watchList")}
            >
              Watch List
            </Button>
            <Button
              variant="contained"
              color={fallBack ? "primary" : "default"}
              onClick={(e) => getActiveButton("fallBack")}
            >
              Fallback List
            </Button>
            <Button
              variant="contained"
              color={q1List ? "primary" : "default"}
              onClick={(e) => getActiveButton("q1List")}
            >
              Q1 List
            </Button>
          </ButtonGroup>
        </Grid>

        <Paper className={classes.root}>
          <div className="vantagesearch">
            <SearchBar
              value={searched}
              onChange={(searchVal) => requestSearch(searchVal)}
              onCancelSearch={() => cancelSearch()}
              style={{ height: "auto", padding: "5px 0" }}
            />
            <TablePagination
              rowsPerPageOptions={[5, 10, 15, 25, 50, 100]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>

          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  {columnList.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      className="prospect_table"
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}
                        onClick={(e) =>
                          handleRequestSort(e, column.id, column.format)
                        }
                      >
                        {column.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.length !== 0 ? (
                  <>
                    {rows
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={index + "a"}
                            className="prospecttable"
                          >
                            {columnList.map((column, index) => {
                              const value = row[column.id];
                              return (
                                <TableCell
                                  key={index + column.id}
                                  align={column.align}
                                >
                                  {column.format &&
                                  typeof value === "number" ? (
                                    Number(value)
                                  ) : column.id === "detailsButton" ? (
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      style={{ borderRadius: 20 }}
                                      onClick={() => viewInvestmentDetails(row)}
                                    >
                                      View Details
                                    </Button>
                                  ) : column.format === "Date" ? (
                                    getDate(value)
                                  ) : column.format === "boolean" &&
                                    row[column.id] ? (
                                    "Yes"
                                  ) : column.format === "boolean" &&
                                    !row[column.id] ? (
                                    "No"
                                  ) : column.id === "concatvalue" ? (
                                    <Typography noWrap>
                                      {concatEfg(row.EFG_min, row.EFG_max)}{" "}
                                    </Typography>
                                  ) : column.id === "options" ? (
                                    <>
                                      <MoreVertRoundedIcon
                                        variant="outlined"
                                        style={{ cursor: "pointer" }}
                                        aria-controls={
                                          index + column.id + "menu"
                                        }
                                        aria-haspopup="true"
                                        onClick={(e) => handleMenuOpen(e, row)}
                                      />
                                      <Menu
                                        anchorEl={anchorEl}
                                        id={index + column.id + "menu"}
                                        keepMounted
                                        open={isMenuOpen}
                                        onClose={handleMenuClose}
                                        getContentAnchorEl={null}
                                        transformOrigin={{
                                          horizontal: "center",
                                          vertical: "bottom",
                                        }}
                                        anchorOrigin={{
                                          horizontal: "right",
                                          vertical: "bottom",
                                        }}
                                      >
                                        <MenuItem
                                          onClick={(e) =>
                                            handleEditRecord(e, row)
                                          }
                                          style={
                                            watchList
                                              ? { display: "block" }
                                              : { display: "none" }
                                          }
                                        >
                                          Edit
                                        </MenuItem>
                                        {/* onClick={e=>handleEditRecord(e,row)} */}
                                        <MenuItem
                                          onClick={(e) =>
                                            handleDeleteRecord(e, row)
                                          }
                                        >
                                          Delete
                                        </MenuItem>
                                        <MenuItem
                                          // onClick={(e) =>
                                          //   handlePatchRecord(e, row, 2)
                                          // }
                                          onClick={(e) => ToggleDialog(e, 2)}
                                          style={
                                            watchList
                                              ? { display: "none" }
                                              : { display: "block" }
                                          }
                                        >
                                          Move to Watch List
                                        </MenuItem>
                                        <MenuItem
                                          // onClick={(e) =>
                                          //   handlePatchRecord(e, row, 3)
                                          // }
                                          onClick={(e) => ToggleDialog(e, 3)}
                                          style={
                                            fallBack
                                              ? { display: "none" }
                                              : { display: "block" }
                                          }
                                        >
                                          Move to Fallback List
                                        </MenuItem>
                                        <MenuItem
                                          // onClick={(e) =>
                                          //   handlePatchRecord(e, row, 1)
                                          onClick={(e) => ToggleDialog(e, 1)}
                                          style={
                                            activeInv
                                              ? { display: "none" }
                                              : { display: "block" }
                                          }
                                        >
                                          Move to Active Investment
                                        </MenuItem>
                                      </Menu>
                                    </>
                                  ) : column.format === "link" && value ? (
                                    <Link
                                      variant="body2"
                                      onClick={(e) => openResearchNote(row)}
                                      gutterBottom
                                      noWrap
                                    >
                                      Re-upload/View
                                    </Link>
                                  ) : column.format === "link" && !value ? (
                                    <Link
                                      variant="body2"
                                      onClick={(e) => openResearchNote(row)}
                                      gutterBottom
                                    >
                                      Upload/View
                                    </Link>
                                  ) : column.id === "Country" ? (
                                    <>
                                      <IconButton>{getFlags(value)}</IconButton>
                                      {" " + value}
                                    </>
                                  ) : value ? (
                                    value
                                  ) : (
                                    "N/A"
                                  )}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                  </>
                ) : (
                  <TableCell
                    colspan="8"
                    style={{ "text-align": "center", margin: "10px 0px" }}
                  >
                    Records Not Available
                  </TableCell>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <Dialog
          open={open}
          onClose={handleClose}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            style={{ cursor: "move", textAlign: "center", paddingTop: 30 }}
            id="draggable-dialog-title"
          >
            Research Note List
          </DialogTitle>
          <DialogContent
            style={{ minHeight: 100, maxHeight: 500, overflow: "hidden" }}
          >
            {researchNoteList.map((obj, inx) => {
              return (
                <Grid container style={{ marginTop: 10 }} key={inx + "rnote"}>
                  {obj.Research_Note && obj.Research_Note !== "" ? (
                    <React.Fragment>
                      <Grid item sm={6} md={6} style={{ paddingLeft: 30 }}>
                        <Link
                          href={staticFiles + obj.Research_Note}
                          target="_blank"
                          style={{
                            maxWidth: "200px",
                            display: "block",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                          title={obj.Research_Note}
                        >
                          {obj.Research_Note}
                        </Link>
                      </Grid>

                      <Grid item sm={4} md={4}>
                        {getDate(obj.note_created_at)}
                      </Grid>

                      <Grid item sm={4} md={1}>
                        <DeleteOutlinedIcon
                          onClick={(e) => deleteResearchNote(e, obj)}
                          style={{ cursor: "pointer" }}
                        ></DeleteOutlinedIcon>
                      </Grid>
                    </React.Fragment>
                  ) : (
                    ""
                  )}
                </Grid>
              );
            })}
          </DialogContent>
          <DialogActions
            style={{
              display: "flex",
              justifyContent: "center",
              paddingBottom: 30,
            }}
          >
            <input
              ref={fileInputRef}
              onChange={handleFileUpload}
              type="file"
              style={{ display: "none" }}
              multiple={false}
            />
            <Button
              onClick={() => fileInputRef.current.click()}
              variant="contained"
              color="primary"
              style={{ paddingLeft: 30, paddingRight: 30 }}
            >
              Upload
            </Button>
            <Button
              onClick={handleClose}
              variant="contained"
              style={{ paddingLeft: 30, paddingRight: 30 }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={deleteopen}
          onClose={handleDeleteClose}
          aria-labelledby="draggable-dialog-delete"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-delete">
            Delete Research Note
          </DialogTitle>
          <DialogContent>
            <span>Are you sure to Delete Research Note?</span>
            <p>Enter OTP</p>

            <input placeholder="OTP" onChange={handleOTP}></input>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteClose} variant="outlined">
              No
            </Button>
            <Button
              autoFocus
              onClick={(e) => submitDelete(e)}
              variant="contained"
              color="primary"
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        {/*  */}
        {/* OTP */}
        <Dialog
          open={dialogopen.watchList}
          onClose={(e) => setDialogopen({ ...dialogopen, watchList: false })}
          aria-labelledby="draggable-dialog-delete"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-delete">
            Move To WatchList
          </DialogTitle>
          <DialogContent>
            <span>
              Do you want to move {currentRecord.Investment_Name} to WatchList?
            </span>
            <p>Enter OTP</p>

            <input placeholder="OTP" onChange={handleOTP}></input>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) =>
                setDialogopen({ ...dialogopen, watchList: false })
              }
              variant="outlined"
            >
              No
            </Button>
            <Button
              autoFocus
              onClick={(e) => handlePatchRecord(e, 2)}
              variant="contained"
              color="primary"
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        {/*  */}
        {/* FallBackList */}
        <Dialog
          open={dialogopen.FallbackList}
          onClose={(e) => setDialogopen({ ...dialogopen, FallbackList: false })}
          aria-labelledby="draggable-dialog-delete"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-delete">
            Move To FallbackList
          </DialogTitle>
          <DialogContent>
            <span>
              Do you want to move {currentRecord.Investment_Name} to
              FallbackList?
            </span>
            <p>Enter OTP</p>

            <input placeholder="OTP" onChange={handleOTP}></input>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) =>
                setDialogopen({ ...dialogopen, FallbackList: false })
              }
              variant="outlined"
            >
              No
            </Button>
            <Button
              autoFocus
              onClick={(e) => handlePatchRecord(e, 3)}
              variant="contained"
              color="primary"
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        {/* Active Invesmtent */}
        <Dialog
          open={dialogopen.activeInvestment}
          onClose={(e) =>
            setDialogopen({ ...dialogopen, activeInvestment: false })
          }
          aria-labelledby="draggable-dialog-delete"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-delete">
            Move To Active Investment
          </DialogTitle>
          <DialogContent>
            <span>
              Do you want to move {currentRecord.Investment_Name} to Active
              Investment?
            </span>
            <p>Enter OTP</p>

            <input placeholder="OTP" onChange={handleOTP}></input>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) =>
                setDialogopen({ ...dialogopen, activeInvestment: false })
              }
              variant="outlined"
            >
              No
            </Button>
            <Button
              autoFocus
              onClick={(e) => handlePatchRecord(e, 1)}
              variant="contained"
              color="primary"
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
}
export default VintageOverView;
